import Aos from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";
import FormComponent from "./FormComponent";

function Banner() {
  useEffect(() => {
    Aos.init({
      once: true,
      duration: 500,
    });
  }, []);

  return (
    <section id="banner" className="position-relative bg-banner">
      <div className="container-lg">
        <div className="row g-0 justify-content-between">
          <div className="col-lg-7 col-xl-7 position-relative banner-wrapper">
            <div className="bannerlist mt-3 px-lg-0">
              <h1 data-aos="fade-up" data-aos-delay="0" data-aos-duration="800">
                ICICI Bank Current <br className="" /> Account for all your{" "}
                <br className="" /> business needs
              </h1>
              <br className="d-md-none" />
              <div className="features">
                <div
                  className="feat"
                  data-aos="fade-in"
                  data-aos-offset="0"
                  data-aos-delay="300"
                  data-aos-duration="800"
                >
                  <img
                    src="dist/img/icons/icon04.svg"
                    alt="icon Insta"
                    width={45}
                    height={45}
                  />
                  <p>
                    Instant <br /> Overdraft
                  </p>
                </div>
                <div
                  className="feat"
                  data-aos="fade-in"
                  data-aos-offset="0"
                  data-aos-delay="500"
                  data-aos-duration="800"
                >
                  <img
                    src="dist/img/icons/icon01.svg"
                    alt="icon Business"
                    width={45}
                    height={45}
                  />
                  <p>
                    Business <br /> Loans
                  </p>
                </div>
                <div
                  className="feat"
                  data-aos="fade-in"
                  data-aos-offset="0"
                  data-aos-delay="700"
                  data-aos-duration="800"
                >
                  <img
                    src="dist/img/icons/icon02.svg"
                    alt="icon Foreign"
                    width={45}
                    height={45}
                  />
                  <p>
                    Export Import <br /> Solutions
                  </p>
                </div>
                <div
                  className="feat"
                  data-aos="fade-in"
                  data-aos-offset="0"
                  data-aos-delay="900"
                  data-aos-duration="800"
                >
                  <img
                    src="dist/img/icons/icon03.svg"
                    alt="icon Merchant"
                    width={45}
                    height={45}
                  />
                  <p>
                    Merchant <br /> Solutions
                  </p>
                </div>
              </div>
              <p className="banner-bottom-line-mobile">
                Use InstaBIZ and Corporate Net Banking{" "}
                <br className="d-block d-sm-none" />
                for business banking 24x7
              </p>
            </div>
          </div>
          <div className="col-lg-4 col-xl-4 mt-2 mt-mb-0 position-relative">
            <FormComponent></FormComponent>
          </div>
        </div>
        <p className="bottom-line">
          Use InstaBIZ and Corporate Net Banking{" "}
          <br className="d-block d-md-none" />
          for business banking 24x7
        </p>
      </div>
      <div className="banner-bottom-line"> &nbsp; </div>
    </section>
  );
}

export default Banner;
